import React from 'react';
import { PROVIDER_TEXT_MAX_LENGTH } from '../../utils/provider';

const ProviderBankAccountsForm = ({
  accounts,
  onAdd,
  onRemove,
  onChange,
  formatRut,
  disabled = false,
}) => {
  return (
    <div className="space-y-4">
      {accounts.length === 0 && (
        <p className="text-sm text-gray-600">Sin cuentas bancarias registradas.</p>
      )}
      {accounts.map((account, index) => (
        <div key={account.id || `new-${index}`} className="border border-gray-200 rounded-lg p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Banco"
              value={account.bankName || ''}
              onChange={(e) => onChange(index, 'bankName', e.target.value)}
              className="border border-gray-300 rounded p-2 w-full"
              maxLength={PROVIDER_TEXT_MAX_LENGTH}
              disabled={disabled}
            />
            <input
              type="text"
              placeholder="Numero de cuenta"
              value={account.bankAccount || ''}
              onChange={(e) => onChange(index, 'bankAccount', e.target.value)}
              className="border border-gray-300 rounded p-2 w-full"
              maxLength={PROVIDER_TEXT_MAX_LENGTH}
              disabled={disabled}
            />
            <select
              value={account.bankAccountType || ''}
              onChange={(e) => onChange(index, 'bankAccountType', e.target.value)}
              className="border border-gray-300 rounded p-2 w-full"
              disabled={disabled}
            >
              <option value="">Tipo de cuenta</option>
              <option value="corriente">Cuenta corriente</option>
              <option value="vista">Cuenta vista</option>
              <option value="ahorro">Cuenta ahorro</option>
              <option value="otro">Otro</option>
            </select>
            <input
              type="text"
              placeholder="RUT titular"
              value={account.bankRut || ''}
              onChange={(e) => onChange(index, 'bankRut', formatRut(e.target.value))}
              className="border border-gray-300 rounded p-2 w-full"
              maxLength={PROVIDER_TEXT_MAX_LENGTH}
              disabled={disabled}
            />
          </div>
          {!disabled && (
            <div className="flex justify-end mt-3">
              <button
                type="button"
                onClick={() => onRemove(account, index)}
                className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
              >
                Eliminar cuenta
              </button>
            </div>
          )}
        </div>
      ))}
      {!disabled && (
        <button
          type="button"
          onClick={onAdd}
          className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600"
        >
          + Agregar cuenta bancaria
        </button>
      )}
    </div>
  );
};

export default ProviderBankAccountsForm;
